export default __webpack_public_path__ + "static/media/tick.3224e644.svg";